import { SettingsSection } from "./SettingsSection";
import { useAuthContext } from "../../context/authContext";
import Moment from "react-moment";

export function Profile() {
  const { state: authState } = useAuthContext();

  const rows = [
    { label: "Full name", value: authState.me.name },
    { label: "Email address", value: authState.me.email },
    { 
      label: "Joined", 
      value: <Moment format="MMMM DD, YYYY">{authState.me.creationDate}</Moment>,
    },
  ];

  return (
    <SettingsSection title="Personal Information">
      <ul className="divide-y divide-gray-100 rounded-xl border border-gray-200 bg-white shadow-sm">
        {rows.map((row) => (
          <li
            key={row.label}
            className="flex flex-col sm:flex-row sm:items-center sm:justify-between
                       px-4 py-4 sm:px-6
                       hover:bg-gray-50 transition-colors duration-150"
          >
            <span className="text-sm font-medium text-gray-900">{row.label}</span>
            <span className="text-sm text-gray-700 mt-1 sm:mt-0">{row.value}</span>
          </li>
        ))}
      </ul>
    </SettingsSection>
  );
}